<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <PageHeader
      class="is-wide"
      inverted
      :title="entity?.title || title"
      :lead="entity?.intro || intro"
    />
    <div class="bg-gray-50">
      <BlokkliField
        :list="paragraphs"
        name="field_paragraphs"
        :allowed-fragments="['in_page_nav']"
      />
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type {
  NodePensionFundFragment,
  ParagraphFundRatioFragment,
} from '#graphql-operations'
import { filterNullArray } from '~/helpers'

const props = defineProps<{
  __typename?: string
  title?: string
  intro?: string
  subtitle?: string
  blokkliProps: NodePensionFundFragment['blokkliProps']
  yearlyInterestRates?: NodePensionFundFragment['yearlyInterestRates']
  paragraphs?: NodePensionFundFragment['paragraphs']
  fundRatios?: NodePensionFundFragment['fundRatios']
}>()

const { htmlClasses } = usePageState({
  pageColor: 'blue',
  hasBackground: true,
})

useHead({
  htmlAttrs: {
    class: htmlClasses,
  },
})

const rates = computed(() => props.yearlyInterestRates || [])
const fundRatios = computed<ParagraphFundRatioFragment[]>(() =>
  filterNullArray(props.fundRatios),
)

provide('node_pension_fund_interest_rates', rates)
provide('node_pension_fund_ratios', fundRatios)
</script>
